export const eye = {
  viewBox: "0 0 24 20",
  path: (
    <>
      <path d="M12 5C5 5 1 12 1 12s4 7 11 7 11-7 11-7-4-7-11-7z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
};

export const eyeOff = {
  viewBox: "0 0 24 20",
  path: (
    <>
      <path d="M2 2l20 20" />
      <path d="M12 5C5 5 1 12 1 12s4 7 11 7c2.1 0 4.06-.5 5.8-1.4" />
      <path d="M9.9 9.9a3 3 0 104.2 4.2" />
      <path d="M18 6.5A11 11 0 0123 12s-4 7-11 7" />
      {/* <path d="M 2 2 l 20 20 M 6 6 C 3 8 1 12 1 12 s 4 7 11 7 c 2.1 0 4.06 -0.5 5.8 -1.4 M 9.9 9.9 a 3 3 0 1 0 4.2 4.2 M 8 5 A 11 11 0 0 1 23 12 s -2 4 -3 4M 2 2 l 20 20 M 6 6 C 3 8 1 12 1 12 s 4 7 11 7 c 2.1 0 4.06 -0.5 5.8 -1.4 M 9.9 9.9 a 3 3 0 1 0 4.2 4.2 M 9 5 A 11 11 0 0 1 23 12 s -1 3 -3 4" /> */}
    </>
  ),
};
